import angular from 'angular';

import TermsPageComponent from './terms-page-component';
import { TermsPageController } from './terms-page-controller';

export default angular
  .module('terms-page', [])
  .controller('TermsPageController', TermsPageController)
  .component('termsPage', TermsPageComponent);



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-page/terms-page-module.js